import React from 'react';
import Box from '../Box';
import InputWrapper from '../InputWrapper';
const Input = _ref => {
  let {
    input,
    ...rest
  } = _ref;
  return /*#__PURE__*/React.createElement(InputWrapper, Object.assign({
    input: input
  }, rest), _ref2 => {
    let {
      error,
      ...inputRest
    } = _ref2;
    return /*#__PURE__*/React.createElement(Box, Object.assign({
      as: "input",
      id: input.name,
      sx: {
        borderColor: error ? 'error' : null,
        overflow: 'hidden',
        textOverflow: 'ellipsis'
      },
      variant: "inputs.primary",
      width: "100%"
    }, inputRest, input));
  });
};
export default Input;